// The ContentEditor document expects to have at least one block node, which is the paragraph by default.
// Deleting the content or running the clearContent command will still result in the document having at least one empty paragraph.
export const checkHtmlNonEmpty = (html: string): boolean =>
  html !== '' && html !== '<p></p>' && html !== '<h2></h2>' && html !== '<h3></h3>';
